// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons
function SocialMediaItem({ link, icon }) {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white text-xl transition-colors duration-200"
    >
      {icon}
    </a>
  );
}

export default SocialMediaItem;
